(function () {
  "use strict";

  // Wave (2026-06-23): the delivery-zone block lives inside the cart drawer, which
  // re-renders on every AJAX cart mutation (add/remove). The old IIFE ran ONCE on
  // load, so after a cart update the freshly-rendered city <select> came back empty
  // and unbound. Refactored into a re-runnable init that re-applies on cart events.
  // Idempotent per node via data-yojo-dz-ready, so it never double-binds.
  //
  // Wave (2026-08-24): three defects found by reading the live cart against this
  // file. All three share one root cause: the answer lived only as a `disabled`
  // attribute on a button this file does not own.
  //
  //  1. SILENT RE-ENABLE. The zone block sits in <aside>, OUTSIDE #AjaxCartSubtotal.
  //     component-cart.js replaces the subtotal's innerHTML on every mutation, so
  //     the checkout button is re-created ENABLED from the server while this root
  //     survives untouched. Pick an out-of-zone city, change a quantity, and the
  //     button turns back on while the <select> still reads the out-of-zone city.
  //
  //     NOTE FOR ANYONE TEMPTED TO FIX THIS BY RE-APPLYING ON 'cart:update':
  //     that does not work. yojo-analytics-events.js emits cart:update from a
  //     fetch response handler (`p.then(onChange)`), which resolves BEFORE the
  //     theme parses the section HTML and calls yojoReplaceCartSubtotal. You would
  //     re-disable the OLD button and then watch it be replaced by a fresh enabled
  //     one. Verified by reading the dispatch order, 2026-08-24.
  //
  //  2. NO PERSISTENCE. No storage, no cookie, no cart attribute. Reload, or
  //     navigate away and back, and an out-of-zone buyer starts unblocked.
  //
  //  3. THE DRAWER CANNOT ASK. cart-aux.liquid renders static prose, not the
  //     <select>, so on any non-cart page the question is structurally absent and
  //     the gate could never apply at all.
  //
  // The fix for all three is the same shape the rest of this theme already uses
  // (yojoCartTruth, yojoCartPhoneGate, yojo-gift-guard): keep the answer in
  // session storage, and enforce with a capture-phase interceptor that reads it at
  // click time. Nothing then depends on a DOM attribute surviving a re-render, and
  // the drawer inherits the gate for free.
  //
  // This gate remains ADVISORY by design (see yojo-delivery-zone.liquid). The
  // checkout-validation Function is the enforcement. The point of this pass is that
  // the advice should stop contradicting itself in front of the customer.

  var STORAGE_KEY = "yojoDeliveryCity";
  var memory = "";

  function readStored() {
    try {
      var v = window.sessionStorage.getItem(STORAGE_KEY);
      return v === null ? memory : v;
    } catch (e) { return memory; }
  }
  function writeStored(value) {
    memory = value || "";
    try {
      if (value) window.sessionStorage.setItem(STORAGE_KEY, value);
      else window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* private mode: `memory` carries it for this page */ }
  }

  function allowSet() {
    var data = document.getElementById("yojo-gush-dan-cities-data");
    var cities = [];
    try { cities = JSON.parse(data ? data.textContent : "[]"); } catch (e) { cities = []; }
    return new Set(cities.map(function (c) { return String(c).trim(); }));
  }

  // T01(b) 2026-09-03 (A3-06): a stale out-of-zone city answered under
  // delivery intent must not keep blocking checkout after the shopper
  // switches to pickup via the chip (cart-aux.liquid) — pickup is not an
  // address question at all.
  function intentIsPickup() {
    var el = document.querySelector("[data-yojo-intent]");
    return !!el && el.getAttribute("data-yojo-intent") === "pickup";
  }

  // The single question this file answers, for anyone who needs it.
  // Unanswered is NOT out-of-zone: we never block a customer who was never asked.
  function isOutOfZone() {
    if (intentIsPickup()) return false;
    var v = readStored();
    if (!v) return false;
    // T01(c) 2026-09-03 (A3-07): "__pickup__" removed from the <select> — the
    // intent chip is the one owner of pickup now, and this select never holds
    // that value any more. See yojo-delivery-zone.liquid for the full note.
    if (v === "__other__") return true;
    var allow = allowSet();
    // If the city list is unavailable (JSON missing on a non-cart page, parse
    // failure), fail OPEN rather than blocking a real in-zone customer.
    if (!allow.size) return false;
    return !allow.has(v.trim());
  }

  function initZone(root) {
    if (!root || root.dataset.yojoDzReady === "1") return;

    var select = root.querySelector("[data-yojo-city-select]");
    var msg = root.querySelector("[data-yojo-zone-msg]");
    var ctas = root.querySelector("[data-yojo-zone-ctas]");
    if (!select || !msg || !ctas) return;
    // T01(d) 2026-09-03 (A1-15): the out-of-zone CTA row's "switch to pickup"
    // button drives the ONE real intent control (the chip in cart-aux.liquid)
    // instead of duplicating it. The chip's own click handler
    // (yojo-cart-intent.js) does the actual /cart/update.js write and re-render.
    var switchPickupBtn = root.querySelector("[data-yojo-zone-switch-pickup]");
    if (switchPickupBtn) {
      switchPickupBtn.addEventListener("click", function () {
        var chip = document.querySelector('[data-yojo-intent-chip="pickup"]');
        if (chip) chip.click();
      });
    }

    // 2026-08-22 out-of-zone waitlist (optional nodes: older cart markup has none).
    var waitlist = root.querySelector("[data-yojo-zone-waitlist]");
    var wlCity = root.querySelector("[data-yojo-waitlist-city]");
    var wlCityText = root.querySelector("[data-yojo-waitlist-city-text]");
    var wlBody = root.querySelector("[data-yojo-waitlist-body]");
    function syncWaitlistBody() {
      if (!wlBody) return;
      var city = (wlCityText && !wlCityText.hidden && wlCityText.value) ? wlCityText.value : (wlCity ? wlCity.value : "");
      wlBody.value = "waitlist | city: " + (city || "?") + " | source: cart-zone-gate";
    }
    function showWaitlist(cityValue) {
      if (!waitlist) return;
      var isOther = cityValue === "__other__";
      if (wlCity) wlCity.value = isOther ? "" : cityValue;
      if (wlCityText) {
        wlCityText.hidden = !isOther;
        if (!isOther) wlCityText.value = "";
      }
      syncWaitlistBody();
      waitlist.hidden = false;
    }
    function hideWaitlist() {
      if (waitlist) waitlist.hidden = true;
    }
    if (wlCityText) wlCityText.addEventListener("input", syncWaitlistBody);

    var allow = allowSet();
    var cities = Array.from(allow);

    // Populate the city <option>s from the canonical JSON list (single source of
    // truth). We do this in JS because the Liquid {% render %} that defines the
    // list runs in an isolated scope, so the server-side <option> loop renders
    // empty. Only inject if the select hasn't already been populated server-side.
    var otherOption = select.querySelector('option[value="__other__"]');
    // Base options are the empty prompt plus "__other__". T01(c) 2026-09-03
    // (A3-07): "__pickup__" retired from this <select> — see the liquid file.
    var baseOptionCount = 2;
    if (allow.size && select.options.length <= baseOptionCount) {
      cities.forEach(function (c) {
        var name = String(c).trim();
        if (!name) return;
        var opt = document.createElement("option");
        opt.value = name;
        opt.textContent = name;
        select.insertBefore(opt, otherOption);
      });
    }

    // 2026-08-25 (PR #308 reconciliation): this block INFORMS, it never sets
    // `disabled`.
    //
    // It used to toggle `disabled` on every checkout button. That was wrong in
    // both directions. It never actually enforced anything — the city picked
    // here has no relationship to the address typed into Shopify checkout, so
    // picking תל אביב and then typing a Haifa address sailed through — while
    // the disabled button raced component-cart.js, which re-renders the cart
    // and replaces the button node, silently dropping the disabled state.
    // It was also the only code in the theme setting `disabled` on that button,
    // which put it in a tug-of-war with the min-order gate (yojoCartTruth),
    // the real owner, which blocks by preventDefault alone.
    //
    // Enforcement now lives where the real address is: the checkout-validation
    // Function, matching on postal code (extensions/delivery-zone-validation).
    // The capture-phase interceptor below stays as the EARLY advisory for an
    // explicit out-of-zone answer; the Function is the authority.
    function setAdvisory(outOfZone, message, isError) {
      if (message) {
        // Write only a change. msg is a polite live region, and re-writing the
        // same words is a childList mutation the re-assert observer below sees,
        // which re-applied this every frame: 580 identical writes in 9.6 s on
        // /cart after one city answer (swarm 2026-10-02, v05 V05-11).
        if (msg.textContent !== message) msg.textContent = message;
        msg.hidden = false;
        msg.classList.toggle("is-error", !!isError);
      } else {
        msg.hidden = true;
      }
      ctas.hidden = !outOfZone;
    }

    // Derives everything from select.value, so it is safe to call repeatedly.
    // `silent` suppresses waitlist churn when we are only restoring state.
    function applyState(silent) {
      var v = select.value;
      if (!v) {
        setAdvisory(false, "", false);
        if (!silent) hideWaitlist();
        return;
      }
      // T01(c) 2026-09-03 (A3-07): "__pickup__" retired — pickup is answered
      // by the intent chip only, never by this select.
      if (v === "__other__" || !allow.has(v.trim())) {
        setAdvisory(true, window.YOJO_DELIVERY_OUT || "", true);
        if (!silent) showWaitlist(v);
        return;
      }
      setAdvisory(false, window.YOJO_DELIVERY_IN || "", false);
      if (!silent) hideWaitlist();
    }

    select.addEventListener("change", function () {
      writeStored(select.value);
      applyState(false);
    });

    // Restore the session's answer. Must run AFTER the options are injected, or
    // assigning select.value silently no-ops and the customer sees "choose a city"
    // while we believe they answered. A stored real city only restores if it is
    // still in the allow-list, so a zone change drops a stale answer instead of
    // honouring it. __other__ is server-rendered and always present. A
    // previously stored "__pickup__" (pre-T01 sessions) is simply not
    // restorable any more — falls through to unanswered, which is correct now
    // that pickup lives only in the intent chip's own state.
    var stored = readStored();
    var restorable =
      stored === "__other__" ||
      (!!stored && allow.has(String(stored).trim()));
    if (stored && restorable) {
      select.value = stored;
      if (select.value === stored) applyState(true);
      else writeStored("");
    }

    root.dataset.yojoDzReady = "1";
    root.yojoDzApply = applyState;
  }

  function initAll() {
    document.querySelectorAll("[data-yojo-delivery-zone]").forEach(function (root) {
      if (root.dataset.yojoDzReady === "1") {
        if (typeof root.yojoDzApply === "function") root.yojoDzApply(true);
        return;
      }
      initZone(root);
    });
  }

  // ---- The actual gate ----------------------------------------------------
  // Capture phase on document, so it runs before the theme's own handlers and
  // regardless of which button instance is currently in the DOM. Same pattern as
  // yojoCartTruth / yojoCartPhoneGate / yojo-gift-guard, which compose with this
  // by each calling preventDefault independently.

  // 2026-08-25: loaded GLOBALLY via yojo-delivery-zone-runtime.liquid — the
  // "drawer inherits the gate for free" promise above was only true on /cart
  // while the script tag lived inside the cart-page-only UI snippet.
  // a[href*="/checkout"] added for parity with yojoCartTruth / the phone gate,
  // so all three gates guard the same trigger set.
  var CHECKOUT_SELECTOR = '#CheckOut, button[name="checkout"], input[name="checkout"], [data-yojo-checkout], a[href*="/checkout"]';

  function announce() {
    var msg = document.querySelector("[data-yojo-zone-msg]");
    var select = document.querySelector("[data-yojo-city-select]");
    if (msg) {
      msg.textContent = window.YOJO_DELIVERY_OUT || "";
      msg.hidden = false;
      msg.classList.add("is-error");
    }
    var ctas = document.querySelector("[data-yojo-zone-ctas]");
    if (ctas) ctas.hidden = false;
    if (select) {
      select.setAttribute("aria-invalid", "true");
      try { select.focus({ preventScroll: false }); } catch (e) { select.focus(); }
      return true;
    }
    return false;
  }

  function gate(event) {
    if (!isOutOfZone()) return;
    event.preventDefault();
    event.stopPropagation();
    // If the zone block is on this page, show the reason in place. If it is not
    // (the drawer on a product or collection page, which has no <select> at all),
    // send them to the cart where the message and the waitlist actually render,
    // rather than silently swallowing the click.
    if (!announce()) {
      try { window.location.assign("/cart"); } catch (e) { window.location.href = "/cart"; }
    }
  }

  document.addEventListener("click", function (event) {
    var target = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!target) return;
    gate(event);
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || form.id !== "cart") return;
    // Only gate a submit that is actually heading to checkout. A plain cart update
    // shares this form; blocking it would strand the customer.
    var submitter = event.submitter;
    if (submitter && submitter.name !== "checkout") return;
    if (!submitter && !form.querySelector('[name="checkout"]')) return;
    gate(event);
  }, true);

  window.yojoDeliveryZone = {
    isOutOfZone: isOutOfZone,
    storedCity: readStored,
    clear: function () { writeStored(""); }
  };

  initAll();
  // The zone block renders in <aside> BEFORE the subtotal that contains the
  // checkout button (main-cart.liquid:355 vs :358), so at first run there is no
  // button to grey out yet and the restored state applies to nothing. The gate
  // still holds (it reads storage at click time), but the button would look
  // available until clicked. Re-assert once the document is complete.
  // Verified on preview 150882386073, 2026-08-24: without this the restored
  // out-of-zone state left btn.disabled === false after a reload.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  }
  window.addEventListener("load", initAll);

  // ...and the theme re-renders the subtotal again AFTER window load, which put a
  // fresh enabled button back. Measured on preview 150882386073, 2026-08-24:
  // window.load re-assert ran, then btn.disabled was false again by the time the
  // page settled. Chasing the ordering is what made the first version of this fix
  // do nothing, so don't: watch for the button being replaced instead.
  // childList only, never attributes. setAdvisory's text write IS a childList
  // mutation, so it is written only when the words change (see setAdvisory), and
  // changes inside the zone block itself are not a re-render to re-assert after.
  if (typeof MutationObserver === "function") {
    var pending = false;
    var outsideZone = function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        var el = t && t.nodeType === 1 ? t : (t && t.parentElement);
        if (!el || !el.closest || !el.closest("[data-yojo-delivery-zone]")) return true;
      }
      return false;
    };
    var observer = new MutationObserver(function (records) {
      if (pending || !outsideZone(records)) return;
      pending = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        pending = false;
        document.querySelectorAll("[data-yojo-delivery-zone]").forEach(function (root) {
          if (root.dataset.yojoDzReady === "1" && typeof root.yojoDzApply === "function") {
            root.yojoDzApply(true);
          }
        });
      }, 0);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  // Re-apply after the cart re-renders. A fresh node gets initialised; an
  // already-ready one gets its visual state re-asserted. Correctness no longer
  // depends on this firing, or on when it fires.
  document.addEventListener("cart:add", initAll);
  document.addEventListener("cart:update", initAll);
})();
